import { lazy } from 'react'
import type { RouteObject } from 'react-router'
const PageFinance = lazy(() => import('./PageFinance').then((m) => ({ default: m.PageFinance })))
export const routesFinance: RouteObject[] = [{ index: true, element: <PageFinance /> }]
